<form action="">
    <div class="form-group">
        <label for="name">Name</label>
        <input type="text" placeholder="Enter Your Name">
    </div>
    <div class="form-group">
        <label for="name">Name</label>
        <input type="text" placeholder="Enter Your Name">
    </div>
    
</form>